/**
 * Schema system_names that denote a person. Indicators never judge a person (a metric on a
 * person is shown, not scored), so the indicator read model and the UI both match a sphere's
 * type chain against this list.
 */
export const PERSON_SPHERE_SCHEMA_SYSTEM_NAMES: readonly string[] = Object.freeze([
  'center_person',
  'center_user',
  'center_identity',
]);
